import React, { useEffect, useState } from "react";
import { getEventsByOrganizationId } from "../../utilities/events/Event";
import { Address, Event } from "../../models";
import BasicSelect, { formattedOption } from "../Select/BasicSelect";
import { formatAddress } from "../../utilities/address/FormatAddress";
import { Spinner } from "reactstrap";

interface _Props {
    organizationId?: string,
    addressValue?: string
    onSelect: Function
}

const SelectAddressByOrganization: React.FC<_Props> = ({organizationId, addressValue, onSelect}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [addressId, setAddressId] = useState<string>(addressValue || "-");
    const [formattedData, setFormattedData] = useState<formattedOption[] | null | undefined>();

    async function getEventsByOrganization(id: string): Promise<Event[] | null> {
        const queryResult = await getEventsByOrganizationId(id);
        const newEvents = queryResult.result;
        if (queryResult.isSuccess) {
            return newEvents;
        } else {
            return null;
        }
    }

    const getAddressesByOrganizationId = async (orgId: string) => {
        setIsLoading(true);
        const orgEvents = await getEventsByOrganization(orgId);
        if (orgEvents && orgEvents.length > 0) {
            let addressList: Address[] = [];
            for (let i = 0; i < orgEvents.length; i++) {
                const event: Event = orgEvents[i];
                if (event.address) addressList.push(event.address);
            }
            formatAddresses(addressList);
        } else {
            setFormattedData([]);
        }
        setIsLoading(false);
    }

    const formatAddresses = (addressList: Address[]) => {
        let formattedAddresses = [];
        for (var i = 0; i < addressList.length; i++) {
            const currentAddress: Address = addressList[i];
            const value = currentAddress?.id || "";
            const label = currentAddress ? formatAddress(currentAddress) : "error";
            let object: formattedOption = {
                value: value,
                label: label,
                object: currentAddress
            };
            formattedAddresses.push(object);
        }
        const sorted = formattedAddresses.sort((a, b) => a.label.localeCompare(b.label));
        setFormattedData(sorted || formattedAddresses);
    }
    
    const getData = async (organizationId: string) => {
        await getAddressesByOrganizationId(organizationId);
    }

    useEffect(() => {
        if (organizationId) getData(organizationId);
    }, [organizationId]);

    useEffect(() => {
        if (addressValue) setAddressId(addressValue);
        else setAddressId("-");
    }, [addressValue]);

    const handleOnChange = (event?: any) => {
        if (event) {
            onSelect(event);
        } else {
            onSelect();
        }
    }

    return (
        <>
            {isLoading ?
                <Spinner />
                :
                <>
                    {formattedData ?
                        <BasicSelect formattedValues={formattedData} isClearable={true} selectedValue={addressId} onSelect={handleOnChange} />
                        :
                        <p>No address options were found.</p>
                    }
                </>
            }
        </>
    );
};

export default SelectAddressByOrganization;